<template>
  <div>

      <catalog-search />
      <catalog-stories />
      <catalog-products />

  </div>
</template>

<script>

import { mapGetters, mapActions, mapMutations } from 'vuex';

import CatalogSearch from "./CatalogSearch";
import CatalogStories from "./CatalogStories";
import CatalogProducts from "./CatalogProducts";

export default {
    name: "index",
    props: ['data'],
    components: { CatalogSearch, CatalogStories, CatalogProducts },

    data(){
      return{
            loadFromCatalog: window.location.pathname === '/catalog' && ! window.location.search.length,
            initialParseUrl: window.location.pathname === '/catalog',
            historyMode: true,
            layoutDictionary: {
                pets: { type: 'animals', needSum: true, filter: 'help' },
                seek_home: { type: 'animals', needSum: false, filter: 'friend' },
                projects: { type: 'projects', needSum: false, filter: 'projects' }
            },

          initialFilter: {
              activePetsFilters: {
                  pet_category_id: [], pet_filter_id: [], city_id: null, only_need_sum: null,
                  donations_filter: null, page: 1, pet_age_category_id: [], size: null, gender: null
              },
              activeProjectsFilters: {
                  project_category_id: [], city_id: null, donations_filter: null, page: 1, allow_autopay: null
              }
          }

        }
    },


    destroyed(){
        window.removeEventListener('popstate', null);
    },

    async created(){

        this.resetState();

        this.setState({ key: 'fetched', data: true });

        const _self = this,
            initial = { data : [], extended_data : { type: "pets" }, last_page: 0 },
            { data, extended_data: { type }, ...rest }  =  this.data || initial,
            layout = this.layoutDictionary[ type ],
            filter = layout.type  ===  'animals'  ?  'filtersPets'  :  'filtersProjects';


        await this.dataForCatalog( layout.type  ===  'animals' ? 'pets' : 'projects' );

        this.setState( { key: 'layoutInitial' , data: { ...layout } } );

        this.resetSliceState({ key: 'list' });
        this.resetSliceState({ key: this.type  ===  'animals'  ?  'activePetsFilters'  :  'activeProjectsFilters' });
        this.resetSliceState({ key: 'search' });

        if( data && data.length ){
            this.setState({ key: 'list', data: { arr: data, meta: rest } })
        } else {
            await this.list({ key: this.type  ===  'animals'  ?  'activePetsFilters'  :  'activeProjectsFilters' })
        }


        window.addEventListener('popstate', function(e){

            let forceUpdate = e.state.l.type !== _self.layoutInitial.type || e.state.l.needSum !== _self.layoutInitial.needSum;

            _self.historyMode = false;
            _self.setByHistory( e.state, true )

        });

    },
    computed: {

        ...mapGetters({ sliceState: 'sliceByKey' }),

        layoutInitial()         { return this.sliceState( 'layoutInitial' ) },

        type()                  { return this.layoutInitial.type },

        needSum()               { return this.layoutInitial.needSum },

        computedActiveFilters() { return this.sliceState( this.layoutInitial.type === 'animals' ? 'activePetsFilters' : 'activeProjectsFilters' ) },

        computedSearch() { return this.sliceState( 'search' ) },

    },

    watch: {

        computedActiveFilters(){
            if( this.initialParseUrl ){
                this.writeUrl( this.computedActiveFilters );
            }
        },

        layoutInitial ( _current, _previous ) {

            const filter = _current.type  ===  'animals'  ?  'filtersPets'  :  'filtersProjects';

            if( ! this.sliceState( filter ) ){
                this.dataForCatalog( _current.type ===  'animals' ? 'pets' : 'projects' );
            }

            if( ! this.initialParseUrl && ! this.loadFromCatalog ){
                new Promise( res => {

                    this.prepareFilters();
                    res();

                } ).then( () => this.setState({ key: 'fetched', data: false }) )
                return;
            }

        },


    },

    methods: {
        ...mapMutations({ setState: 'setterByKey', resetSliceState: 'resetByKey', resetState: 'resetCatalog' }),

        ...mapActions({ dataForCatalog: 'getInitDataForCatalog', list: 'getList' }),

        setByHistory({ l, c, s }, forceUpdate = false){

            new Promise( res => {

                this.resetSliceState({ key: 'list' });
                this.setState({ key: 'fetched', data: true })
                this.resetSliceState({ key: this.type  ===  'animals'  ?  'activePetsFilters'  :  'activeProjectsFilters' });
                this.resetSliceState({ key: 'search' });

                if( l ) this.setState({ key: 'layoutInitial', data: l });
                if( s ) this.setState({ key: 'search', data: s });
                if( c ) this.setState({
                    key: this.layoutInitial.type === 'animals' ? 'activePetsFilters' : 'activeProjectsFilters' ,
                    data: { ...c }
                });
                res();
            } ).then( () => {

                if( forceUpdate ){
                    this.list({ key: this.type  ===  'animals'  ?  'activePetsFilters'  :  'activeProjectsFilters' })
                }

            } )



        },

        async prepareFilters(){

            const location = window.location,
                  { extended_data: { city = null } } = this.data,
                  type = location.pathname.indexOf('/catalog/pets') >= 0 || location.pathname.indexOf('/catalog/seek_home') >= 0  ?
                    'activePetsFilters' : 'activeProjectsFilters';
            let prepareFilters = {}

            if( type === 'activePetsFilters' ){
                prepareFilters.only_need_sum = location.pathname.indexOf('/catalog/pets')  >=  0  ?  1  :  0
            }

            if( window.location.search.length ){
                let  searchParams = window.location.search.substring(1);

                searchParams = searchParams.split('&');
                searchParams = searchParams.map( key => decodeURI(key) );
                for (let i = 0; i < searchParams.length; i++){
                    let a = searchParams[ i ].split('=');

                    if( a[ 0 ].match(/\[(\d+)?\]$/) ){

                        a[ 0 ] = a[ 0 ].replace(/\[(\d+)?\]/, '')
                        if(! prepareFilters[ a[0] ]) prepareFilters[ a[ 0 ] ] = [];
                        prepareFilters[ a[ 0 ] ].push( a[ 1 ] )

                    } else {

                        prepareFilters[ a[ 0 ] ] = a[ 1 ];

                    }

                }
            }

            if(city){
                let c = { citySearch: city.name, citySelected : city.name, city_id : city.id, cities: [] };
                this.setState( { key: 'search' , data: { ...c } } );
                prepareFilters.city_id = c.city_id
            }

            prepareFilters = { ...this.initialFilter[ type ], ...prepareFilters }
            this.setState( { key: type , data: { ...Object.assign({}, this.computedActiveFilters, prepareFilters ) } } );
            this.initialParseUrl = true;

        },

        writeUrl( target ){

            let qs = '',
                catalog = '/catalog';

            if( ! this.loadFromCatalog ){
                const layout =  target.only_need_sum ? 'pets' : this.layoutInitial.type === 'animals' ? 'seek_home' :  'projects';
                catalog = `/catalog/${layout}`;

                qs = Object.keys(target).map(function(key) {

                    let s = '';

                    if(
                        ! target[ key ]
                        || ( Array.isArray( target[ key ] ) && ! target[ key ].length )
                        || key === 'only_need_sum'
                        || ( + target[ key ] === 1 && key === 'page' )
                    ) return;

                    if( Array.isArray( target[ key ] ) && target[ key ].length ){

                        s += target[ key ].map( ( a, _i ) => `${key}[]=${a}` ).join('&');

                        return s;
                    }

                    return s = `${key}=${target[ key ]}`
                }).filter( val => !!val ).join('&');

            }

            if( ! this.historyMode ) return this.historyMode = true;

            if( qs.length ) history.pushState({ l: this.layoutInitial, s: this.computedSearch, c: this.computedActiveFilters },"", `${catalog}?${qs}`);
            else history.pushState({ l: this.layoutInitial, s: this.computedSearch, c: this.computedActiveFilters },"", `${catalog}`);

            this.loadFromCatalog = false;

        }


    }

}
</script>

<style lang="scss">
.page-numbers.current a {
    color: #fff !important;
}

.page-numbers:hover a {
    color: #fff !important;
}
.catalog--empty{
    text-align: center;
    font-size: 22px;
}

</style>

<style lang="scss" scoped>



</style>
